import type { ADFEntity } from '@atlaskit/adf-utils/types';
import type { EditorActions } from '@atlaskit/editor-core';

export const updateNodeParameters = (
	editorActions: EditorActions,
	updatedParameters: any,
): boolean => {
	const selectedNodeJSON = editorActions.getSelectedNode()?.toJSON();

	const updatedNodeSelection = {
		...selectedNodeJSON,
		attrs: {
			...selectedNodeJSON?.attrs,
			parameters: { ...updatedParameters },
		},
	};

	return editorActions.replaceSelection(updatedNodeSelection, true);
};

export const replaceSelectedNode = (editorActions: EditorActions, nodeAdf: ADFEntity): boolean => {
	return editorActions.replaceSelection(nodeAdf, true);
};
